import AppDownloadsPie from "./AppDownloadsPie";

export default AppDownloadsPie;
